// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kdF01C0FPWNm_bOuplTx {
  max-width: var(--content-column);
  margin: 0 auto;
  width: 100%
}

.kdF01C0FPWNm_bOuplTx.KSUPgv7JjV6jDLTRfXNp {
    max-width: 39.75rem;
  }

@media only screen and
  (min-width: 1280px) {
  .kdF01C0FPWNm_bOuplTx {
    padding: 0 var(--content-padding)
  }

    .kdF01C0FPWNm_bOuplTx.jB7s8y3YL7ZlowqMHa4Q {
      padding: 6rem var(--content-padding);
    }

    .kdF01C0FPWNm_bOuplTx.KSUPgv7JjV6jDLTRfXNp {
      padding: 0;
    }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .kdF01C0FPWNm_bOuplTx {
    padding: 0 var(--content-padding-desktop-small)
  }

    .kdF01C0FPWNm_bOuplTx.jB7s8y3YL7ZlowqMHa4Q {
      padding: 5rem var(--content-padding-desktop-small);
    }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .kdF01C0FPWNm_bOuplTx {
    padding: 0 var(--content-padding-tablet)
  }

    .kdF01C0FPWNm_bOuplTx.jB7s8y3YL7ZlowqMHa4Q {
      padding: 4rem var(--content-padding-tablet);
    }
}

@media only screen and
  (max-width: 639px) {
  .kdF01C0FPWNm_bOuplTx {
    padding: 0 var(--content-padding-mobile)
  }

    .kdF01C0FPWNm_bOuplTx.jB7s8y3YL7ZlowqMHa4Q {
      padding: 3rem var(--content-padding-mobile);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/LayoutWrapper/LayoutWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,cAAc;EACd;AAKF;;AAHE;IACE,mBAAgB;EAClB;;AAGF;;EACE;IACE;EASF;;IAPE;MACE,oCAAoC;IACtC;;IAEA;MACE,UAAU;IACZ;AAEJ;;AAEA;;;EACE;IACE;EAKF;;IAHE;MACE,kDAAkD;IACpD;AAEJ;;AAEA;;;EACE;IACE;EAKF;;IAHE;MACE,2CAA2C;IAC7C;AAEJ;;AAEA;;EACE;IACE;EAKF;;IAHE;MACE,2CAA2C;IAC7C;AAEJ","sourcesContent":[".layoutWrapper {\n  max-width: var(--content-column);\n  margin: 0 auto;\n  width: 100%;\n\n  &.narrow {\n    max-width: 636px;\n  }\n}\n\n@media (--desktop-large) {\n  .layoutWrapper {\n    padding: 0 var(--content-padding);\n\n    &.defaultVertical {\n      padding: 96px var(--content-padding);\n    }\n\n    &.narrow {\n      padding: 0;\n    }\n  }\n}\n\n@media (--desktop-small) {\n  .layoutWrapper {\n    padding: 0 var(--content-padding-desktop-small);\n\n    &.defaultVertical {\n      padding: 80px var(--content-padding-desktop-small);\n    }\n  }\n}\n\n@media (--tablet) {\n  .layoutWrapper {\n    padding: 0 var(--content-padding-tablet);\n\n    &.defaultVertical {\n      padding: 64px var(--content-padding-tablet);\n    }\n  }\n}\n\n@media (--mobile) {\n  .layoutWrapper {\n    padding: 0 var(--content-padding-mobile);\n\n    &.defaultVertical {\n      padding: 48px var(--content-padding-mobile);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutWrapper": `kdF01C0FPWNm_bOuplTx`,
	"narrow": `KSUPgv7JjV6jDLTRfXNp`,
	"defaultVertical": `jB7s8y3YL7ZlowqMHa4Q`
};
export default ___CSS_LOADER_EXPORT___;
